module.exports = __webpack_public_path__ + "img/fa.9219b4a5.svg";